// Where every "back to the quotes list" and post-save redirect should land.
//
// Two listings exist: /user/quotations/listing (UserQuotationListing — the one
// the Fixed Ops Command Center nav points at, and the one carrying the row
// actions) and /admin/quotations/listing (AdminQuotationListing, menu-gated to
// Super Admin in routes.js). The create/edit/details/preview screens all used
// to send you to the admin one, so a normal seller finished a quote on a list
// their own sidebar never shows.
//
// Behind a constant so the two don't drift apart again.
export const QUOTES_LIST_ROUTE = "/user/quotations/listing";

export default QUOTES_LIST_ROUTE;
